/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Converter_Distance_ShortInputs */

const en_ui_labs_converter_distance_short = /** @type {(inputs: Ui_Labs_Converter_Distance_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance`)
};

const de_ui_labs_converter_distance_short = /** @type {(inputs: Ui_Labs_Converter_Distance_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanz`)
};

/**
* | output |
* | --- |
* | "Distance" |
*
* @param {Ui_Labs_Converter_Distance_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_converter_distance_short = /** @type {((inputs?: Ui_Labs_Converter_Distance_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Converter_Distance_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_converter_distance_short(inputs)
	return de_ui_labs_converter_distance_short(inputs)
});